import {ActionType} from './../../../Models/ActionType';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {SolutionService} from '../../../Services/solution.service';
import {Solution} from '../../../Models/Solution';
import {Subscription} from 'rxjs';
import {SolutionStep} from '../../../Models/SolutionStep';
import {Router} from '@angular/router';

@Component({
  selector: 'app-solution-template',
  templateUrl: './solution-template.component.html',
  styleUrls: ['./solution-template.component.scss']
})
export class SolutionTemplateComponent implements OnInit, OnDestroy {
  public solution: Solution = new Solution();
  private subscriptions: Subscription[] = [];
  public actionTypes: ActionType[] = [];
  public isStepsValidate = false;

  constructor(
    private solutionService: SolutionService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.solutionService.solution.subscribe(solution => {
        this.solution = solution;
        this.validateSteps();
      })
    );

    this.solutionService.getActionTypes().then((actionTypes) => {
      this.actionTypes = actionTypes;
      this.validateSteps();
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  AddStep() {
    this.solution.solutionSteps.push(new SolutionStep());
    this.solutionService.solution.next(this.solution);
  }

  submitSolution() {
    this.validateSteps();
    if (this.isStepsValidate) {
      this.solutionService.manageSolutionSteps(this.solution).subscribe(() => {
        this.router.navigateByUrl('/back-office/service/solution/overview');
      });
    }
  }

  private validateSteps() {
    if (!this.solution.solutionSteps.length || !this.actionTypes.length) {
      this.isStepsValidate = false;
      return;
    }

    this.isStepsValidate = this.solution.solutionSteps.every((item) => {
      const validators = {
        'confirmation': (action) => this.validateActionConfirm(action),
        'form': (action) => this.validateActionForm(action),
        'text': () => true,
        'email': () => true,
        'packaging_label': () => true,
        'invoice': () => true,
        're_order': () => true,
        'change_status': (action) => this.validateActionChangeStatus(action)

      };

      const currentActionType = this.actionTypes.find(actionType => actionType.id === item.actionType);

      if (!currentActionType) {
        return false;
      }

      return validators[currentActionType.name](item);
    });
  }

  private validateActionConfirm(solutionStep: SolutionStep): boolean {
    const actionConfirm = solutionStep.actionConfirm;
    return !!(actionConfirm.message || actionConfirm.primaryOption || actionConfirm.secondaryOption);
  }

  private validateActionForm(solutionStep: SolutionStep): boolean {
    const actionForm = solutionStep.actionForm;
    return !!actionForm.title;
  }

  private validateActionChangeStatus(solutionStep: SolutionStep): boolean {
    const actionChangeStatus = solutionStep.actionChangeStatus;
    return !!(actionChangeStatus && actionChangeStatus.status);
  }
}
